<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      v-if="isLoading"
      @dataAvailable="
        data => {
          orders = data?.metaData?.orders
          totalPages = Math.ceil(data?.metaData?.total / 6)
          this.isLoading = false
        }
      "
      :searchQuery="{ page: currentPage, limit: 6, status: activeStatus }"
      contentId="orders"
      eventToListen="none"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 bg-[#f4f4f5] pt-8 z-[2]"
    >
      <div class="text-4xl title-color">Commandes</div>
    </div>
    <div v-if="isLoading || orders.length > 0">
      <div class="py-4"></div>
      <div class="sticky top-16 bg-[#f4f4f5] py-3 pt-6">
        <div class="flex justify-between items-center">
          <div
            class="w-full md:w-auto grid grid-cols-3 md:flex gap-4 p-1 bg-white rounded-2xl"
          >
            <button
              class="relative px-4 py-2 rounded-xl flex items-center justify-center"
              v-for="(status, i) in statuses"
              :key="i"
              @click="activeStatus = status.id"
            >
              <div
                :class="{
                  'w-full h-full bg-primary': activeStatus == status.id,
                  'w-0 h-0 bg-transparent': activeStatus !== status.id,
                }"
                class="duration-300 absolute rounded-xl"
              ></div>
              <div
                class="relative"
                :class="{
                  'text-white': activeStatus == status.id,
                  '': activeStatus !== status.id,
                }"
              >
                {{ status.name }}
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="py-4"></div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          v-for="(el, i) in isLoading ? shimmerOrders : filteredOrders"
          :key="i"
          class="bg-white border rounded-3xl p-4 flex flex-col shadow-b-xl"
          :class="{ shimmerElement: el.shimmer, ripple: !el.shimmer }"
          @click="
            () => {
              if (el.shimmer) return
              $Events.dispatchEvent('order_details_requested', el)
            }
          "
        >
          <div
            class="flex justify-between items-center border-b border-dashed pt-2 pb-4"
          >
            <div class="flex items-center gap-2">
              <div
                class="items-center gap-2 flex text-primary text-sm font-medium py-2 px-4 ripple !pointer-events-auto"
                @click.stop="
                  $Commons.copy(
                    el.publicId || el.id || '-',
                    'Numéro de commande copié',
                  )
                "
              >
              <div>
                
                #{{ el.publicId || el.id }}
              </div>
              <div class="w-5 h-5">
                <img
                  class="w-full h-full"
                  src="@/assets/images/all/copy.svg"
                  alt=""
                />
              </div>
              </div>
              <!-- <span class="text-gray-400 text-xs">•</span>
            <span class="text-gray-500 text-sm">{{ el.shippingMethod }}</span> -->
            </div>
            <div class="flex items-center gap-3">
              <div
                class="py-1 px-3 rounded-lg flex items-center gap-2 relative"
                :style="{
                  backgroundColor: statuses[el.status]?.background,
                  color: statuses[el.status]?.color,
                }"
              >
                <div>
                  {{ statuses[el.status]?.name || el.status }}
                </div>
                <!-- <div class="w-5 h-5">
                  <img
                    class="w-full h-full"
                    src="@/assets/images/all/pen.svg"
                    alt=""
                  />
                </div> -->
              </div>
              <div class="w-8 h-8">
                <img
                  class="w-full h-full"
                  src="@/assets/images/all/eye.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="py-2"></div>

          <div
            class="flex gap-6 flex-col py-2"
            v-if="el.products && el.products[0]"
          >
            <div
              class="flex justify-between items-start gap-4"
              v-for="(product, i) in el.products.slice(0, 2)"
              :key="i"
            >
              <div class="flex items-start gap-3 w-4/5">
                <div class="h-14 w-14 min-w-14 rounded-xl overflow-hidden">
                  <img
                    :src="product.image"
                    class="w-full h-full object-cover"
                  />
                </div>
                <div class="">
                  <p class="title-color">
                    {{ product.name }}
                  </p>
                  <!-- <div class="pt-1"></div> -->
                  <p class="text-sm">
                    {{ product.quantity }} x {{ product.price }} FCFA
                  </p>
                  <div class="pt-1"></div>
                </div>
              </div>
              <span class="md:text-xl title-color text-right">
                {{ product.price }}&nbsp;FCFA
              </span>
            </div>
            <div v-if="el.products[2]" class="flex justify-between items-start">
              <div class="flex items-center gap-3 w-4/5">
                <div
                  class="h-14 w-14 rounded-xl overflow-hidden border bg-slate-200"
                >
                  <img
                    src="@/assets/images/empty/no-product.png"
                    class="w-full h-full object-cover"
                  />
                </div>
                <div class="">
                  <p class="title-color">
                    {{ el.products.length - 2 }} Produit suplémentaires
                  </p>
                  <div class="pt-1"></div>
                  <p class="text-sm">
                    <!-- {{ product.quantity }} x {{ product.price }} FCFA -->
                  </p>
                  <div class="pt-1"></div>
                  <!-- <p v-if="el.products.length > 1" class="text-sm">
                  +{{ el.products.length - 1 }} Other Product(s)
                </p> -->
                </div>
              </div>
              <span class="text-xl title-color">
                <!-- {{ product.price }} FCFA -->
                <!-- {{ el.totalPrice }} -->
              </span>
            </div>
          </div>

          <div class="py-2 mt-auto"></div>
          <div class="flex gap-12">
            <div>
              <div class="text-sm">Date</div>
              <div class="pt-1"></div>
              <div class="text-sm md:text-base title-color">
                {{
                  $Commons.timestampToDate(el.orderDate, 'DD MMM YYYY, hh:mm')
                }}
              </div>
            </div>
            <div>
              <div class="text-sm">Client</div>
              <div class="pt-1"></div>
              <div class="text-sm md:text-base title-color">
                {{ el.customerName }}
              </div>
            </div>
            <div>
              <div class="text-sm">Méthode de paiement</div>
              <div class="pt-1"></div>
              <div class="text-sm md:text-base title-color">
                {{ paymentMethods[el.paymentMethod] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="py-2"></div>
      <div class="flex justify-center" v-if="!isLoading">
        <Pagination
          :currentPage="currentPage"
          :totalPages="totalPages"
          @pageClick="newPage => (currentPage = newPage)"
        />
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/5">
        <img src="@/assets/images/empty/no-order.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">
          Aucune commande en disponible
        </div>
        <div class="py-1"></div>
        <div class="text-lg">Vous n'avez aucune commande. <br /></div>
        <div class="py-3"></div>
        <div class="flex justify-center gap-6">
          <router-link to="/products" class="buttonComponent">
            Créer ou partager des produits
          </router-link>
        </div>
      </div>
    </div>
    <EventListener
      :events="['order_status_updated', 'failed_to_update_order_status']"
      @order_status_updated="onOrderStatusUpdated"
      @failed_to_update_order_status="onOrderStatusNotUpdated"
    />
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DotLottieComponent from '@/components/utils/DotLottieComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import Pagination from '@/components/utils/Pagination.vue'

export default {
  name: 'homeComponent',
  components: { DataGetter, DotLottieComponent, EventListener, Pagination },
  data() {
    return {
      eventsIds: [],
      orders: [],
      activeTab: 'home',
      isLoading: true,
      shimmerOrders: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      statuses: {
        "": { id: '', name: 'Tout' },
        initial: {
          id: 'initial',
          name: 'Paiement en cours',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        paid: {
          id: 'paid',
          name: 'Payé',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        paymentFailed: {
          id: 'failed',
          name: 'Paiement échoué',
          background: '#EEF2F3',
          color: '#696969',
        },
        processing: {
          id: 'processing',
          name: 'Livraison en cours',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        delivered: {
          id: 'delivered',
          name: 'Délivré',
          background: '#EAEEFF',
          color: '#2930B5',
        },
        refunded: { id: 'refunded', name: 'Rémboursé' },
        // failed: {
        //   id: 'failed',
        //   name: 'Echoué',
        //   background: '#EEF2F3',
        //   color: '#696969',
        // },
      },
      paymentMethods: {
        card: 'Carte bancaire',
        mobileMoney: 'Mobile Money',
      },
      activeStatus: '',
      currentPage: 1,
      totalPages: 0,
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    setActiveStatus(statusId) {
      this.activeStatus = statusId
    },
    async startStatusUpdate(order) {
      const options = [
        {
          id: 'processing',
          name: 'Livraison en cours',
        },
        {
          id: 'delivered',
          name: 'Délivré',
        },
        { id: 'refunded', name: 'Rémboursé' },
      ]
      const prompt = await window.choicePrompt({
        title: "Modifier l'état de la commande",
        subtitle:
          'Cette modification permettra au client de savoir où en est sa commande',
        options,
        formatDisplay: data => data?.name || '',
        successText: 'Enrégistrer',
      })
      if (!prompt.accepted || !prompt.data) return null
      console.log(prompt.data)
      this.$Events.dispatchEvent('start_loading')
      this.$Events.dispatchEvent('order_status_update_available', {
        id: order.id,
        status: prompt.data.id,
      })
    },
    onOrderStatusUpdated() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Nouvel état enrégistré',
        body: 'Nous avons enrégistré le nouvel état de la commande. Le client le verra de son coté',
      })
    },
    onOrderStatusNotUpdated() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: "Echec d'enrégistrement",
        body: "Nous n'arrivons pas à modifier l'état de la commande, veuilez réessayer",
      })
    },
  },
  computed: {
    filteredOrders() {
      if (this.activeStatus == '') return this.orders
      return this.orders.filter(order => order.status == this.activeStatus)
    },
  },
  watch: {
    currentPage() {
      this.isLoading = true
    },
    activeStatus() {
      this.isLoading = true
      this.currentPage = 1
    },
  },
}
</script>
